export default __webpack_public_path__ + "static/media/ic_scooter_block.b76a732e.svg";